angular.module('impactx.purchaseorder').controller('SentDeliveryOverdueCtrl', [
    '$scope',
    '$mdDialog',
    'sentDeliveryOverdueMails',
    'themeFactory',
    'abortLabel',
    'headerLabel',
    SentDeliveryOverdueCtrl]);

function SentDeliveryOverdueCtrl($scope, $mdDialog, sentDeliveryOverdueMails, themeFactory, abortLabel, headerLabel)
{
    $scope.theme = themeFactory.getTheme();
    $scope.abortLabel = abortLabel;
    $scope.headerLabel = headerLabel;
    $scope.sentDeliveryOverdueMails = sentDeliveryOverdueMails;
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
}